import { render, staticRenderFns } from "./class-over-list.html?vue&type=template&id=3ff0d4ae&"
import script from "./class-over-list.ts?vue&type=script&lang=ts&"
export * from "./class-over-list.ts?vue&type=script&lang=ts&"
import style0 from "./class-over-list.styl?vue&type=style&index=0&lang=styl&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports